import { OrderProvider } from "@/contexts/OrderContext";
import OrderHeader from "../order/OrderHeader";
import { AudioProvider } from "@/contexts/AudioContext";
import { FolderClockIcon } from "lucide-react";

export default function Orders() {
    return <div className="flex flex-col h-screen min-h-0">
        <OrderHeader title={"Commandes"} />
        
        <div className="flex flex-grow flex-col items-center justify-center h-screen">
            <FolderClockIcon className="w-16 h-16 mb-4" />
            <h1 className="text-xl font-bold">Commandes disponibles</h1>
            <p className="text-md mb-4 text-center">Cette fonctionnalité n’est pas encore disponible.<br />
                En attendant, merci d’utiliser Rocket.Chat pour accepter les commandes.</p>
        </div>
    </div>
}